import React, { useEffect, useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';

const CardYear = props => {
    const year = props.year ?? '-'
    const totalActivity = props.totalActivity ?? null
    const homeRoomFeature = props.homeRoomFeature ?? null
    const classGrade = props.grade ?? 'SECONDARY'

    useEffect(() => {
    }, [year, totalActivity, homeRoomFeature, classGrade]);

    return (
        <Card className="font-sarabun" data-testid="dashboard-card-homeroom-grade-year">
            <ListGroup variant="flush">
                <ListGroup.Item className="font-weight-bold text-center bg-lightness4-blue py-2" data-testid="dashboard-card-homeroom-grade-year-label">{classGrade == 'SECONDARY' ? 'ม.' : 'ป.'}{year}</ListGroup.Item>
                <ListGroup.Item>
                    <Row>
                        <Col xs={12} lg={6} className="text-center px-0">
                            <div className="border-right-solid">
                                <h4 className="mb-0">นักเรียน</h4>
                                <h2 className="mb-0 font-weight-bold" data-testid="dashboard-card-homeroom-grade-year-total-student">{totalActivity && totalActivity.totalStudents ? totalActivity.totalStudents : '-'}</h2>
                            </div>
                        </Col>
                        <Col xs={12} lg={6} className="text-center px-0">
                            <h4 className="mb-0">คุณครู</h4>
                            <h2 className="mb-0 font-weight-bold" data-testid="dashboard-card-homeroom-grade-year-total-teacher">{totalActivity && totalActivity.totalTeachers ? totalActivity.totalTeachers : '-'}</h2>
                        </Col>
                    </Row>
                </ListGroup.Item>

                {homeRoomFeature ?
                    <div>
                        {totalActivity && totalActivity.totalActivities ?
                            <div>
                                <ListGroup.Item className="bg-dark2-blue text-center pb-0" style={{ "border": "none" }}>
                                    <div style={{ "borderBottom": "1px dashed #B6C2D5" }}>
                                        <h6 className="mb-0 gray-text5">จำนวนครั้งกิจกรรม</h6>
                                        <h3 className="mb-0 font-primary-color font-weight-bold mb-2" data-testid="dashboard-card-homeroom-grade-year-total-count">{totalActivity && totalActivity.totalActivities ? totalActivity.totalActivities : '-'} รอบ</h3>
                                    </div>
                                </ListGroup.Item>
                                <ListGroup.Item className="bg-dark2-blue text-center">
                                    <h6 className="mb-0 gray-text5">คิดเป็นช่วงเวลาเชิงบวก</h6>
                                    <h3 className="mb-0 font-primary-color font-weight-bold" data-testid="dashboard-card-homeroom-grade-year-total-minute">{totalActivity && totalActivity.totalActivities ? totalActivity.totalActivities * 20 : '0'} นาที</h3>
                                </ListGroup.Item>
                            </div>
                            :
                            <div>
                                <ListGroup.Item className="bg-dark2-blue text-center pb-0" style={{ "border": "none" }}>
                                    <div style={{ "height": "144px", "display": "flex" }}>
                                        <h6 className="gray-text5" style={{ "margin": "auto" }}>ยังไม่ได้ทำกิจกรรม<br></br>Homeroom</h6>
                                    </div>
                                </ListGroup.Item>
                            </div>
                        }
                    </div>
                    : <div></div>
                }

            </ListGroup>
        </Card>
    )

}

export default CardYear